import { DateTime } from 'luxon';
import { DISCOUNT_END_DATE } from 'shared';

/**
 * Check if the 50% discount campaign is currently active
 */
export const isDiscountActive = (): boolean => {
  const now = DateTime.now();
  const endDate = DateTime.fromISO(DISCOUNT_END_DATE);
  return now <= endDate;
};

/**
 * Check if a specific date is within the discount period
 */
export const isDateWithinDiscountPeriod = (date: DateTime): boolean => {
  const endDate = DateTime.fromISO(DISCOUNT_END_DATE);
  return date <= endDate;
};
